/* eslint-disable consistent-return */
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { ScrollParallax } from 'react-just-parallax';
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { Form, Formik } from 'formik';
import { ArrowRightIcon, CheckIcon } from '@heroicons/react/24/outline';
import FormFieldAndError from '../common/FormFieldAndError';
import 'react-toastify/dist/ReactToastify.css';

export default function Contact() {
  const [btnWait, setBtnWait] = useState(false);
  const [btnSuccess, setBtnSuccess] = useState(false);
  const router = useRouter();

  const post = (values) => {
    if (btnWait) {
      return toast.error('Lo sentimos, hubo un error', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    }

    const data = {
      name: values.Name,
      email: values.Email,
      phone: values.Phone,
      subject: values.Subject,
      message: values.Message,
    };
    setBtnWait(true);

    axios({
      method: 'post',
      url: `${process.env.NEXT_PUBLIC_API}/leads`,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(() => {
        setBtnSuccess(true);
        router.push('/gracias');
        toast.success('Su mensaje ha sido enviado', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      })
      .catch((error) => {
        console.log(error);
        setBtnWait(false);

        toast.error('Lo sentimos, hubo un error', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const ContactSchema = Yup.object().shape({
    Name: Yup.string()
      .required('Requerido')
      .min(5, 'Debe tener al menos 5 caracteres')
      .max(75, 'No debe tener más de 75 caracteres'),

    Phone: Yup.string()
      .required('Requerido')
      .min(7, 'Debe tener al menos 7 caracteres')
      .max(20, 'No debe tener más de 20 caracteres'),

    Email: Yup.string()
      .email('Debe ser un Email valido')
      .required('Requerido')
      .min(5, 'Debe tener al menos 5 caracteres')
      .max(125, 'No debe tener más de 75 caracteres'),

    Message: Yup.string()
      .required('Requerido')
      .min(15, 'Debe tener al menos 15 caracteres')
      .max(400, 'No debe tener más de 400 caracteres'),
  });

  return (
    <>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <div className="relative w-full pt-[50px] ">
        <ScrollParallax>
          <div className="relative w-full h-[400px] md:h-[500px]">
            <div
              className="absolute z-50 w-full h-full"
              style={{
                background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%)',
              }}
            />
            <Image
              fill
              src="/images/contact.jpg"
              alt="Background"
              className="object-cover object-center"
            />
          </div>
        </ScrollParallax>
        <h1 className="hidden">Contacto</h1>
        <div className="absolute top-0 w-full px-5">
          <div className="flex flex-col  justify-center w-full mt-[50px] max-w-xl mx-auto  h-[500px] md:max-w-5xl 2xl:max-w-7xl">
            <div className="pb-5 text-3xl md:pb-12 md:text-5xl payfair text-brand-main">
              <p className="p-2 my-2 bg-white w-fit" data-aos="fade-up" data-aos-delay="">
                ¡Me encantaría saber de ti!
              </p>
            </div>
          </div>
        </div>
      </div>
      <section className="relative z-10 px-5 py-10 overflow-hidden bg-white md:py-20 ">
        <div className="w-full max-w-xl mx-auto md:max-w-4xl 2xl:max-w-4xl">
          <p className="text-base payfair md:text-lg max-w-prose">
            Estoy aquí para responder tus preguntas y guiarte en tu camino hacia el crecimiento
            personal y profesional. Me esfuerzo por responder todos los correos electrónicos durante
            nuestro horario comercial habitual, de lunes a viernes de 9 a.m. a 4 p.m. EST.
          </p>
          <Formik
            initialValues={{
              Name: '',
              Email: '',
              Phone: '',
              Message: '',
            }}
            validationSchema={ContactSchema}
            onSubmit={post}
          >
            {({ errors, touched }) => (
              <Form
                action="#"
                noValidate
                className="grid grid-cols-2 gap-3 mt-10 md:gap-5 text-brand-main"
              >
                <div className="flex flex-col col-span-full gap-y-2">
                  <FormFieldAndError
                    labelText="Nombre y Apellido"
                    btnSuccess={btnSuccess}
                    extraClass=""
                    errors={errors}
                    touched={touched}
                    name="Name"
                  />
                </div>
                <FormFieldAndError
                  labelText="Email"
                  btnSuccess={btnSuccess}
                  extraClass=""
                  errors={errors}
                  touched={touched}
                  name="Email"
                />
                <FormFieldAndError
                  labelText="Teléfono"
                  btnSuccess={btnSuccess}
                  extraClass=""
                  errors={errors}
                  touched={touched}
                  name="Phone"
                />
                <div className="flex flex-col col-span-full gap-y-2">
                  <FormFieldAndError
                    btnSuccess={btnSuccess}
                    errors={errors}
                    touched={touched}
                    extraClass="mx-auto min-h-[200px]"
                    name="Message"
                    labelText="Mensaje"
                    as="textarea"
                  />
                </div>
                <button
                  type="submit"
                  aria-label="Submit"
                  className={`relative inline-block text-sm font-bold ml-auto col-span-full text-white bg-brand-btn hover:bg-brand-dark/80   group w-fit ${
                    btnSuccess && 'pointer-events-none brightness-75'
                  }`}
                >
                  <span
                    className={`relative flex items-center justify-center  ${
                      btnSuccess || (btnWait && 'w-12 h-12')
                    }  text-white opensans-bold gap-x-2`}
                  >
                    <span className="flex items-center px-10 payfair gap-x-1 h-[45px]">
                      {btnSuccess && !btnWait ? (
                        <CheckIcon />
                      ) : (
                        !btnWait && (
                          <>
                            Enviar
                            <ArrowRightIcon className="w-4 h-4" />
                          </>
                        )
                      )}
                      {btnWait && <PuffLoader size="20px" color="#fff" />}
                    </span>
                  </span>
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </section>
    </>
  );
}
